import {MenuItemDef} from "@ag-grid-community/core";

// DP-2999 scaffold: context-menu factory for the "Snooze indicator for N
// minutes" row action. Wired into ManifestDetailsContextMenu behind the
// `backendColorRules` flag. Follow-up ticket fills in the mutation call.

export enum SnoozeIndicatorMenuText {
  SnoozeIndicator = "Snooze indicator"
}

const SNOOZE_OPTIONS_MINUTES = [5, 15, 30, 60];

type GetSnoozeIndicatorMenuItemDefArgs = {
  disabled?: boolean;
  onSnooze: (minutes: number) => void;
};

export const getSnoozeIndicatorMenuItemDef = ({disabled, onSnooze}: GetSnoozeIndicatorMenuItemDefArgs): MenuItemDef => {
  return {
    name: SnoozeIndicatorMenuText.SnoozeIndicator,
    disabled: disabled ?? false,
    subMenu: SNOOZE_OPTIONS_MINUTES.map<MenuItemDef>((minutes) => ({
      name: `${minutes} minutes`,
      action: () => onSnooze(minutes)
    }))
  };
};
